import React, { useState } from "react";

import Item from "./Item";

const Component = ({ items, ...rest }) => {
  const [checkedItem, setCheckedItem] = useState();

  return items.map((data, index) => {
    return (
      <Item
        data={data}
        checkedItem={checkedItem}
        setCheckedItem={setCheckedItem}
        key={index}
        {...rest}
      />
    );
  });
};

Component.propTypes = {};

Component.defaultProps = {};

export default Component;
